import { Link } from "react-router-dom";
import ClassData from "../Class.json";
import { FiMail } from "react-icons/fi";
import logo from "../assets/images/1.png";
import React, { useState, useEffect, useRef } from "react";
import { TfiYoutube } from "react-icons/tfi";
import {FaAngleDown,FaAngleRight,} from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import {BiLogoFacebook,BiLogoInstagram,} from "react-icons/bi";


const LargeScreen = () => {
const [isOpen, setIsOpen] = useState(false);
const lastScrollY = useRef(0);
const [showHeader, setShowHeader] = useState(true);

// const [lastScrollY, setLastScrollY] = useState(0);

useEffect(() => {
  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY < 20) {
      setShowHeader(true);
    } else if (currentScrollY > lastScrollY.current) {
      setShowHeader(false);
    } else {
      setShowHeader(true);
    }

    lastScrollY.current = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);


  const buttonColors = [
    "from-[#4D96FF] to-[#6BCB77]",

    "from-[#9B5DE5] to-[#4D96FF]",

    "from-[#FF6B6B] to-[#FF8E53]",

    "from-[#FFD93D] to-[#FF9F1C]",

    "from-[#20C997] to-[#0D6EFD]"
  ];

  const cardColors = [
    "bg-[#FFF0F0]",

    "bg-[#EEF7FF]",

    "bg-[#F4FFF0]",

    "bg-[#FFF8E8]",

    "bg-[#F4F0FF]",

    "bg-[#FFEDED]",

    "bg-[#E8FFF7]",

    "bg-[#FFF2F2]",
  ];

  const links = [
    {
      name: "Test Paper",

      link: "https://bhavyapublications.in/testpaper/",
    },
    {
      name: "Ayansh Test Paper",

      link: "https://bhavyapublications.in/testpaper25/",
    },

    {
      name: "Studio Keys",

      link: "https://bhavyapublications.in/pdfviewerstudios/index.html",
    },

    {
      name: "Ayansh Keys",

      link: "https://bhavyapublications.in/pdfviewerayansh/index.html",
    },

    {
      name: "Vision Keys",

      link: "https://bhavyapublications.in/pdfviewervision/index.html",
    },
  ];

  return (
    // <div className="hidden md:block top-0 z-50">
    <div
  className={`
    hidden md:block
    fixed
    top-0
    left-0
    w-full
    z-50
    transition-transform
    duration-700
    ease-in-out
    ${
showHeader
? "translate-y-0 opacity-100"
: "-translate-y-full opacity-95"
}
  `}
>

      {/* Top Bar */}

      <div className="bg-gradient-to-r from-[#4D96FF] via-[#9B5DE5] to-[#FF6B6B]">

        <div className="max-w-7xl mx-auto px-8">

          <div className="h-14 flex items-center justify-between text-white">

            <div className="flex items-center gap-2 text-sm">

              <FiMail />

              <a
                href="mailto:bhavyapublications@gmail.com"
                className="hover:text-yellow-200 transition"
              >

                bhavyapublications@gmail.com

              </a>

            </div>

            <div className="flex flex-wrap gap-3 justify-end">

              <a
                href="/"

                className="hover:scale-125 transition duration-300"
              >

                <BiLogoFacebook size={22} />

              </a>

              <a
                href="/"

                className="hover:scale-125 transition duration-300"
              >

                <BiLogoInstagram size={22} />

              </a>

              <a
                href="https://www.youtube.com/@Bhavyapublications"

                className="hover:scale-125 transition duration-300"
              >

                <TfiYoutube size={18} />

              </a>

            </div>

            <div className="flex items-center gap-2 text-sm">

              <BsFillTelephoneFill />

              <span>

                NEED HELP? +91-9897901611

              </span>

            </div>

          </div>

        </div>

      </div>

      {/* Navbar */}

      <div className="bg-[#FFF9F4] py-4">

        <div className="max-w-7xl mx-auto px-8 relative">

          {/* Floating Decorations */}

          <div className="absolute top-2 left-20 w-8 h-8 bg-[#FFD93D] rounded-full opacity-30 animate-bounce"></div>

          <div className="absolute top-5 right-40 w-6 h-6 bg-[#FF6B6B] rounded-full opacity-30 animate-pulse"></div>

          <div className="absolute top-14 left-[45%] w-5 h-5 bg-[#6BCB77] rounded-full opacity-30 animate-ping"></div>

          <div className="bg-gradient-to-r from-white via-[#fffef8] to-[#fffaf4] rounded-full shadow-xl px-10 h-24 flex items-center justify-between border border-orange-100">

            {/* Logo */}

            <Link to="/">

              <img
                src={logo}
                alt="logo"
                className="h-14 hover:scale-105 transition duration-300"
              />

            </Link>

            {/* Menus */}

            <ul className="flex items-center gap-12 text-lg font-bold">

              {/* Home */}

              <li>

                <Link
                  to="/"

                  className="hover:text-[#FF6B6B] transition"
                >

                  🏠 Home

                </Link>

              </li>

              {/* Books */}

              <li
                className="relative"

                onMouseEnter={() => setIsOpen(true)}

                onMouseLeave={() => setIsOpen(false)}
              >

                <button className="flex items-center gap-2 hover:text-[#FF6B6B] transition">

                  📚 Books

                  {isOpen ?

                    <FaAngleDown />

                    :

                    <FaAngleRight />

                  }

                </button>

                {/* Mega Menu */}

                <div
                  className={`

                  absolute

                  top-14

                  left-[-240px]

                  w-[750px]

                  bg-white

                  rounded-3xl

                  shadow-2xl

                  p-8

                  z-50

                  transition-all

                  duration-300

                  ${
                    isOpen

                      ? "opacity-100 visible translate-y-0"

                      : "opacity-0 invisible -translate-y-3"
                  }

                  `}
                >

                  <h2 className="text-3xl font-bold text-[#4D96FF] mb-6">

                    📚 Explore Our Books

                  </h2>

                  <div className="grid grid-cols-4 gap-5">

                    {ClassData.map((item, id) => (

                      <Link
                        key={id}

                        to={item.direct}
                      >

                        <div
                          className={`

                          ${cardColors[id % cardColors.length]}

                          rounded-3xl

                          p-5

                          hover:scale-105

                          hover:rotate-1

                          hover:shadow-xl

                          transition-all

                          duration-300

                          `}
                        >

                          <div className="text-4xl">

                            📘

                          </div>

                          <div className="font-semibold text-[#444] mt-2">

                            {item.classCategory}

                          </div>

                        </div>

                      </Link>

                    ))}

                  </div>

                </div>

              </li>

              {/* Contact */}

              <li>

                <Link
                  to="/contact"

                  className="hover:text-[#FF6B6B] transition"
                >

                  📞 Contact

                </Link>

              </li>

            </ul>

            {/* Buttons */}

            <div className="flex gap-3 ">

              {links.map((item, index) => (

                <a
                  key={index}

                  href={item.link}

                  target="_blank"

                  rel="noopener noreferrer"

                  className={`

                  px-3

                  py-2

                  rounded-full

                  text-sm

                  font-semibold

                  text-white

                  bg-gradient-to-r

                  ${buttonColors[index]}

                  hover:scale-105

                  hover:-translate-y-1

                  hover:shadow-xl

                  transition-all

                  duration-300

                  `}
                >

                  {item.name}

                </a>

              ))}

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default LargeScreen;